import React from 'react';
import './App.css';
import MapVeto from './components/MapVeto';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1>CS2 Map Veto System</h1>
      </header>
      <main>
        <MapVeto />
      </main>
    </div>
  );
}

export default App;